<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                        <th>Naam</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td>{{item.naam}}</td>
                        <td nowrap>
                            <router-link :to="'/beheer/soortbelichting/edit/' + item.id" title="Belichtingssoort wijzigen"><i class="fa fa-pencil-square-o"></i></router-link>
                            &nbsp;
                            <a title="Belichtingssoort verwijderen" href="javascript:void(0)" @click="bevestigItem(item.id, item.naam)" v-show="item.deleteok"><i class="fa fa-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><router-link class="page-link" to="/beheer/soortbelichting/new">Belichtingssoort toevoegen</router-link></li>
                    </ul>
                </nav>
            </div><!--/.row-->
        </div>

        <b-modal title="Verwijderen" size="sm" v-model="warningModal" @ok="deleteItem">
            Soort belichting <b>{{name}}</b> wordt verwijderd. Bent u zeker?
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'List',
        props: ['items'],
        data () {
            return {
                id: -1,
                name: '',
                warningModal: false,
            };
        },
        methods: {
            bevestigItem (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal = true;
            },
            deleteItem () {
                this.warningModal = false;
                this.$emit('delete-item', this.id);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/soortbelichting/List.vue